<!-- One dropdown trigger + panel, rendered once per NavMenu. Opens on hover via
     the `group` classes; the (click) toggle is a fallback for touch devices. -->
<ng-template #dropdown let-menu>
  <div class="relative group">
    <button
      type="button"
      (click)="toggleMenu(menu.key, $event)"
      class="flex items-center gap-1 text-[13px] font-medium px-3 py-1.5 whitespace-nowrap
             transition-all duration-150 cursor-pointer border-none bg-transparent
             hover:text-white hover:bg-white/10"
      [class]="isMenuActive(menu) ? '!text-white font-semibold' : 'text-white/80'"
      [attr.aria-expanded]="openMenu() === menu.key"
      aria-haspopup="true"
    >
      {{ menu.label }}
      <svg
        width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
        stroke-linecap="round" class="transition-transform duration-200 group-hover:rotate-180"
        [class.rotate-180]="openMenu() === menu.key"
      >
        <path d="M6 9l6 6 6-6"/>
      </svg>
    </button>

    <!-- Padded wrapper keeps the hover region continuous between the trigger and the panel -->
    <div class="absolute left-0 top-full pt-1 hidden group-hover:block z-50" [class.!block]="openMenu() === menu.key">
      <div class="w-56 bg-surface border border-border shadow-lg py-1">
        @for (link of menu.links; track link.path) {
          <a
            [routerLink]="link.path"
            routerLinkActive="bg-primary-light text-primary font-semibold"
            (click)="closeMenu()"
            class="block px-4 py-2 text-sm text-[#222] no-underline
                   hover:bg-canvas transition-colors duration-100"
          >
            {{ link.label }}
          </a>
        }
      </div>
    </div>
  </div>
</ng-template>

<nav class="fixed inset-x-0 top-0 z-50 h-[60px] bg-primary flex items-center px-4 gap-8">

  <!-- Logo -->
  <img src="/images/healppy-logo.png" class="h-[40px]" alt="Healppy Logo" priority/>

  <!-- Nav links — centred -->
  <div class="flex-1 flex items-center justify-center gap-0.5">
    @for (link of navLinks; track link.path) {
      <a
        [routerLink]="link.path"
        routerLinkActive="!text-white font-semibold"
        [routerLinkActiveOptions]="{ exact: true }"
        class="text-white/80 text-[13px] font-medium px-3 py-1.5 whitespace-nowrap
               no-underline transition-all duration-150
               hover:text-white hover:bg-white/10"
      >
        {{ link.label }}
      </a>
    }

    <ng-container [ngTemplateOutlet]="dropdown" [ngTemplateOutletContext]="{ $implicit: ordersMenu }" />

    @for (link of trailingNavLinks; track link.path) {
      <a
        [routerLink]="link.path"
        routerLinkActive="!text-white font-semibold"
        class="text-white/80 text-[13px] font-medium px-3 py-1.5 whitespace-nowrap
               no-underline transition-all duration-150
               hover:text-white hover:bg-white/10"
      >
        {{ link.label }}
      </a>
    }

    <ng-container [ngTemplateOutlet]="dropdown" [ngTemplateOutletContext]="{ $implicit: productsMenu }" />
  </div>

  <!-- Utility icons -->
  <div class="flex items-center gap-2 flex-shrink-0">
    <hp-profile-dropdown></hp-profile-dropdown>
  </div>

</nav>
